import { toggleMark } from 'prosemirror-commands';
import { Mark } from 'prosemirror-model';
import { CommandProps } from '../types';
import { BaseMark } from './base/BaseMark';

export class Italic extends BaseMark {
  constructor() {
    super('em');
  }

  get schema() {
    return {
      parseDOM: [
        { tag: 'i' },
        { tag: 'em' },
        { style: 'font-style=italic' },
        { style: 'font-style=normal', clearMark: (m: Mark) => m.type.name == 'em' },
      ],
      toDOM() {
        return ['em', 0] as const;
      },
    };
  }

  commands({ schema }: CommandProps) {
    return {
      'Mod-i': toggleMark(schema.marks.em),
    };
  }
}
